import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';

const QUICK_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/masjid', label: 'Masjid' },
  { to: '/classes', label: 'Classes' },
  { to: '/contact', label: 'Contact' },
] as const;

const NotFoundPage: React.FC = () => {
  const location = useLocation();
  const path = location.pathname || '/';

  return (
    <>
      <main className="not-found-page">
        <div className="not-found-page__veil" aria-hidden />
        <div className="container not-found-page__content">
          <p className="not-found-page__code" aria-hidden>
            404
          </p>
          <span className="not-found-page__eyebrow">Page not found</span>
          <h1 className="not-found-page__title">Does not exist</h1>
          <p className="not-found-page__lead">
            <code className="not-found-page__path">{path}</code>
          </p>
          <div className="not-found-page__actions">
            <Link to="/" className="btn btn-primary btn-lg rounded-pill btn-glow">
              <i className="bi bi-house-door me-2" aria-hidden />
              Back to home
            </Link>
            <Link to="/contact" className="btn btn-outline-light btn-lg rounded-pill not-found-page__secondary">
              <i className="bi bi-chat-dots me-2" aria-hidden />
              Contact us
            </Link>
          </div>
          <nav className="not-found-page__links" aria-label="Helpful links">
            {QUICK_LINKS.map((item) => (
              <Link key={item.to} to={item.to} className="not-found-page__link">
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFoundPage;
